/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateDefaultInstrumentBackfill} from '../api'

export const useMutationUpdateDefaultInstrumentBackfill = createReactQueryMutationHook('updateDefaultInstrumentBackfill', updateDefaultInstrumentBackfill)
